import { Drawer } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../../../../assets/logo.png";
import BlueCross from "../../../../assets/profile/icons/blueCross.svg";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import {
  profileSideMenuOpenSelector,
  setProfileSideMenuClose,
} from "../../../../store/features/profileSlice";
import { useAppDispatch } from "../../../../store/store";
import { profileSidebarItems } from "../../constants";
import { SidebarButton } from "../SidebarButton";

export const ProfileMobileSideBar = ({
  activeTab,
  handleTabChange,
}: {
  activeTab: string;
  handleTabChange: any;
}) => {
  const navigate = useNavigate();
  const langTheme = useLanguageTheme();

  const { t, i18n } = useTranslation(["profile"]);
  const dispatch = useAppDispatch();

  const openSideNav = useSelector(profileSideMenuOpenSelector);

  const content = (
    <div
      className="profile-mobile-sidebar"
      style={{
        fontFamily: langTheme.mainFont(),
      }}
    >
      <div className="profile-mobile-sidebar-header">
        <img
          src={logo}
          style={{ width: "97px" }}
          onClick={() => navigate("/home")}
        />
        <img
          src={BlueCross}
          alt="Blue cross"
          onClick={() => dispatch(setProfileSideMenuClose())}
        />
      </div>

      <div
        style={{
          maxWidth: "175px",
          width: "100%",
          marginTop: "20px"
        }}
      >
        {profileSidebarItems.map((item) => (
          <SidebarButton
            key={item.value}
            icon={item.icon}
            label={t(item.label)}
            active={activeTab === item.value}
            onClick={() => handleTabChange(item.value)}
          />
        ))}
      </div>
    </div>
  );

  return (
    <Drawer
      transitionDuration={400}
      anchor="top"
      open={openSideNav}
      onClose={() => dispatch(setProfileSideMenuClose())}
      PaperProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 1)",
          width: "100%",
          direction: i18n.dir(),
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "transparent",
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};
